import { DEV } from "solid-js"
import { Color } from "three"
import Unexpected from "../../../Exception/Unexpected.class"
import type { NeighborColorCollection } from "./createNodeNeighborBaseColorCollection"

const oneHalf = 1 / 2
const oneFourth = 1 / 4

let r = 0, g = 0, b = 0
function resetRGB() {
  r = 0
  g = 0
  b = 0
}
function add(c: Color, weight: number): void {
  r += c.r * weight
  g += c.g * weight
  b += c.b * weight
}

/**
 * Weighted interpolation of elevation at an arbitrary point inside a tile.
 *
 * @param weights   WeightsV2 from calculateNeighborWeights
 * @param elev      ColorsV2 for base + 8 neighbours
 * @returns         The interpolated elevation
 */
export default function createNodeNeighborAvgColorCollection(
  collection: NeighborColorCollection,
): NeighborColorCollection {

  if (DEV) {
    if (collection.list.length !== 8) {
      throw new Unexpected('collection.list.length !== 8')
    }
  }

  const { base, list: [
    northColor,
    northEastColor,
    eastColor,
    southEastColor,
    southColor,
    southWestColor,
    westColor,
    northWestColor,
  ] } = collection

  // const northColorAvg = base.clone().lerp(northColor, oneHalf)
  // const eastColorAvg = base.clone().lerp(eastColor, oneHalf)
  // const southColorAvg = base.clone().lerp(southColor, oneHalf)
  // const westColorAvg = base.clone().lerp(westColor, oneHalf)

  // const northWestColorAvg = (base + northColor + westColor + northWestColor) / 4
  // const northEastColorAvg = (base + northColor + eastColor + northEastColor) / 4
  // const southWestColorAvg = (base + southColor + westColor + southWestColor) / 4
  // const southEastColorAvg = (base + southColor + eastColor + southEastColor) / 4

  const northColorAvg = new Color()
  const eastColorAvg = new Color()
  const southColorAvg = new Color()
  const westColorAvg = new Color()
  const northWestColorAvg = new Color()
  const northEastColorAvg = new Color()
  const southWestColorAvg = new Color()
  const southEastColorAvg = new Color()

  resetRGB()
  add(base, oneHalf)
  add(northColor, oneHalf)
  northColorAvg.setRGB(r, g, b)
  resetRGB()
  add(base, oneHalf)
  add(eastColor, oneHalf)
  eastColorAvg.setRGB(r, g, b)
  resetRGB()
  add(base, oneHalf)
  add(southColor, oneHalf)
  southColorAvg.setRGB(r, g, b)
  resetRGB()
  add(base, oneHalf)
  add(westColor, oneHalf)
  westColorAvg.setRGB(r, g, b)
  resetRGB()
  add(base, oneFourth)
  add(northColor, oneFourth)
  add(westColor, oneFourth)
  add(northWestColor, oneFourth)
  northWestColorAvg.setRGB(r, g, b)
  resetRGB()
  add(base, oneFourth)
  add(northColor, oneFourth)
  add(eastColor, oneFourth)
  add(northEastColor, oneFourth)
  northEastColorAvg.setRGB(r, g, b)
  resetRGB()
  add(base, oneFourth)
  add(southColor, oneFourth)
  add(westColor, oneFourth)
  add(southWestColor, oneFourth)
  southWestColorAvg.setRGB(r, g, b)
  resetRGB()
  add(base, oneFourth)
  add(southColor, oneFourth)
  add(eastColor, oneFourth)
  add(southEastColor, oneFourth)
  southEastColorAvg.setRGB(r, g, b)

  const list = [
    northColorAvg,
    northEastColorAvg,
    eastColorAvg,
    southEastColorAvg,
    southColorAvg,
    southWestColorAvg,
    westColorAvg,
    northWestColorAvg,
  ]
  return { base, list }
}
